import { Component, OnInit, Inject } from '@angular/core';
import { Globals } from '../../../../globals'
import { IepService } from "../../../../Services/IepService";
import { ISpedStudentDemographics } from '../../../../Models/ISpedStudentDemographics'
import { IIepInstance } from '../../../../Models/IIepInstance'
import { Message } from 'primeng/primeng';
import { ILockStatus } from '../../../../Models/ILockStatus';
import { Router } from "@angular/router";
import { ILookupSite } from '../../../../Models/ILookupSite';
import { LookupService } from 'src/app/Services/LookupService';
import { FormSpecialFactorsService } from '../../../../Services/FormSpecialFactorsService';
import { IFormSpecialFactors } from "../../../../Models/Forms/IFormSpecialFactors";
import { IReportParameter } from 'src/app/Models/IReportParameter';
import { SpinnerBase } from '../../../Base/SpinnerBase';
import { ReportService } from 'src/app/Services/ReportService';

@Component({
  selector: 'SpecialFactors',
  templateUrl: './SpecialFactors.component.html',
  styleUrls: ['./SpecialFactors.component.css']
})

export class FormSpecialFactorsComponent extends SpinnerBase implements OnInit {

  _myGlobals: Globals;
  _baseUrl: string;
  _iepService: IepService;
  successMessages: Message[];
  errorMessages: Message[];
  studentInfo: ISpedStudentDemographics;
  selectedIepInstance: IIepInstance;
  isLocked: boolean;
  lockStatus: string;
  canEditIep: boolean;
  saveClicked: boolean;
  panel1: boolean;
  panel2: boolean;
  panel3: boolean;
  panel4: boolean;
  panelNumber: number;
  lookupSite: any = [];
  lookupSiteName: string;
  lookupSiteAddress: string;
  lookupSiteList: ILookupSite[];
  _lookupService: LookupService;
  formSpecialFactorsDB: any = [];
  reportParamArray: IReportParameter[];
  //public showSpinner: boolean = false;

  constructor
    (
      private globals: Globals, reportService: ReportService,
      iepService: IepService,
      @Inject('BASE_URL') baseUrl: string,
      public router: Router,
      lookupService: LookupService,
      private _formSpecialFactorsService: FormSpecialFactorsService) {
      super(reportService);
    this._iepService = iepService;
    this._myGlobals = globals;
    this._baseUrl = baseUrl;
    this.studentInfo = this._myGlobals.spedStudentDemographics;
    this.selectedIepInstance = this._myGlobals.selectedIepInstance;
    this._lookupService = lookupService;
  }

  ngOnInit(): void {
    this.LoadFormSpecialFactorsDetails();
    this.isLocked = false;
    this.canEditIep = this._myGlobals.canEdit();
    this.successMessages = [];
    this.errorMessages = [];
    this.scrollToTop();
  }

  LoadFormSpecialFactorsDetails(): void {
    this._formSpecialFactorsService.getFormSpecialFactors(this._myGlobals.selectedFormDetails.formId)
      .subscribe((res: IFormSpecialFactors) => {
        this.formSpecialFactorsDB = res
        this.formSpecialFactorsDB.studentRequiresPrimaryLanguageSupport = this.studentInfo.elStatusCode == '3' ? true : false;
      },
        err => console.error(err)
      );
  }

  clearMessages() {
    this.successMessages = [];
    this.errorMessages = [];
  }

  addMessage(msg: Message) {
    if (msg.severity == 'error') {
      this.errorMessages = [...this.errorMessages, msg];
    }
    else {
      this.successMessages = [...this.successMessages, msg];
    }
  }

  loadUnLock(action) {
    this._iepService.lockUnlockForm(this._baseUrl + 'api/Iep/LockUnlockForm?formInstanceId='
      + this._myGlobals.selectedFormDetails.formInstanceId + '&action=' + action)
      .subscribe((res: ILockStatus) => {
        this.isLocked = res.success
        this.lockStatus = res.status
      },
        err => console.error(err)
      );
  }
   
  edit() {
    this.clearMessages();
    this.saveClicked = false;
    this._iepService.lockUnlockForm(this._baseUrl + 'api/Iep/LockUnlockForm?formInstanceId='
      + this._myGlobals.selectedFormDetails.formInstanceId + '&action=Lock')
      .subscribe((res: ILockStatus) => {
        this.isLocked = res.success
        this.lockStatus = res.status
        if (this.isLocked == true) {
          this.globals.editMode = true;
        }
        else {
          let failedMessage: Message = { severity: 'warn', summary: this.lockStatus }
          this.addMessage(failedMessage);
        }
      });
  }

  //Save the conference Invitation
  save(action) {
    this.scrollToTop();
    this.clearMessages();
    this.saveClicked = true;

    //update values
    this._formSpecialFactorsService.insertUpdateFormSpecialFactors(this.formSpecialFactorsDB)
      .subscribe((res: IFormSpecialFactors) => {
        let successMessage: Message = { severity: 'success', summary: 'Record Saved Successfully', detail: res.id.toString() }
        this.addMessage(successMessage);
        if (action == 'Close') {
          this.globals.editMode = false;
          this.loadUnLock("UnLock");
        }
        this.saveClicked = false
        this.LoadFormSpecialFactorsDetails();
      },
        (error) => {
          let errorMessage: Message = { severity: 'error', summary: 'Save Failed', detail: error };
          this.addMessage(errorMessage);
          this.saveClicked = false;
        }
      )

  }

  cancel() {
    this.clearMessages();
    this.globals.editMode = false;
    this.loadUnLock("UnLock");
    this.LoadFormSpecialFactorsDetails();
  }

  populateReportParameters() {
    this.reportParamArray = [];
    this.reportParamArray.push(
      { parameterName: 'RequestID', parameterValue: '0' },
      { parameterName: 'isDraft', parameterValue: 'True' },
      { parameterName: 'FormInstanceID', parameterValue: this.formSpecialFactorsDB.iepFormInstanceId.toString() },
      { parameterName: 'ShowCustomWaterMark', parameterValue: this._myGlobals.selectedDashboardDocument.status == 'Draft' ? 'true' : 'false' },
      { parameterName: 'CustomWatermarkText', parameterValue: 'DRAFT DRAFT DRAFT' },
      { parameterName: 'BlankForm', parameterValue: 'false' },
      { parameterName: 'IEPID', parameterValue: this.formSpecialFactorsDB.iepId.toString() }
    );
  }

  printEnglish() {
    this.populateReportParameters();
    this.printFormCommon(this.formSpecialFactorsDB.rdlFileNameEnglish, this.reportParamArray);
  }

  printSpanish() {
    this.populateReportParameters();
    this.printFormCommon(this.formSpecialFactorsDB.rdlFileNameSpanish, this.reportParamArray);
  }

}
